<button mat-raised-button color="primary"
		(click)="onNext()">
	<i class="fal fa-shopping-cart"></i> {{ (this.orderablePackageType !== FollowupPackageType.Refinement ? 'Order next package' : 'Order chargeable refinement') | translate}}
</button>
